<template>
  <div class="box-forgot">
    <h2 class="form-title">Password reset</h2>
    <div>
      <div class="expired-token-box" v-show="recoveryTokenHasExpired">
        <h3>
        Recovery token has expired. 
        <a href="/forgot-password">Click here</a> to receive a new recovery email.
        </h3>
      </div>
    </div>
    <div id="resetCompleted" v-if="passwordResetSuccess">
      <h2 class="success-reset-text">
      Your password has been successfully reset. 
      <a :href="dsAppUrl">Click here</a> to log in to Dropsmart.
      </h2>
    </div>
    <div id="formContainer" v-if="!recoveryTokenHasExpired && !passwordResetSuccess">
      <form @submit.prevent="submitResetPasswordForm()" autocomplete="off">
        <input type="hidden" name="token" id="token" v-model="token" />
        <b-input-group class>
          <span class="formIcons email">
            <EmailIcon />
          </span>
          <b-form-input
            type="email"
            name="email"
            size="lg"
            id="email"
            placeholder="E-MAIL"
            aria-describedby="email-feedback"
            v-model="resetForm.email"
            disabled
          ></b-form-input>
          <b-form-invalid-feedback
            id="email-feedback"
            v-bind:tooltip="false"
          >Must be a valid email address.</b-form-invalid-feedback>
        </b-input-group>
        <!-- Password Input -->
        <b-input-group class>
          <span class="formIcons password">
            <PasswordIcon />
          </span>
          <b-form-input
            size="lg"
            type="password"
            name="password"
            ref="password"
            id="password"
            placeholder="CREATE A NEW PASSWORD"
            aria-describedby="password-feedback"
            v-model="resetForm.password"
          ></b-form-input>
          <b-form-invalid-feedback id="password-feedback" v-bind:tooltip="false">
            Your password must be at least 8
            characters.
          </b-form-invalid-feedback>
        </b-input-group>
        <!-- Password Input -->
        <b-input-group class>
          <span class="formIcons password">
            <PasswordIcon />
          </span>
          <b-form-input
            size="lg"
            type="password"
            name="passwordCheck"
            id="passwordCheck"
            v-model="resetForm.passwordCheck"
            placeholder="CONFIRM YOUR NEW PASSWORD"
            aria-describedby="password-feedback"
          ></b-form-input>
          <b-form-invalid-feedback id="password-feedback" v-bind:tooltip="false">
            Your password must be at least 8
            characters.
          </b-form-invalid-feedback>
        </b-input-group>
        <p
          class="info-reset"
        >The password should be at least eight characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like ! " ? $ % ^ & ).</p>
        <div id="error-message" v-show="errorMessage">{{this.errorMessage}}</div>
        <button class="green-button-white-text" type="submit">
          <b-spinner v-show="showLoad"></b-spinner>
          <span id="button-text" v-if="!showLoad">Reset password</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { BACKEND_URL, FRONTEND_URL } from "../config.js";
import EmailIcon from "./icons/EmailIcon.vue";
import PasswordIcon from "./icons/PasswordIcon.vue";

export default {
  props: {
    token: {
      type: String,
    }
  },
  data() {
    return {
      baseUrl: BACKEND_URL.Base,
      dsAppUrl: FRONTEND_URL.AppLoginPage,
      showLoad: false,
      passwordResetSuccess: false,
      errorMessage: null,
      recoveryInfo: null,
      resetForm: {
        email: null,
        password: null,
        passwordCheck: null,
        token: null,
      },
    };
  },
  computed: {
    recoveryTokenHasExpired: function () {
      return this.recoveryInfo && this.recoveryInfo.expired;
    },
  },
  components: {
    PasswordIcon,
    EmailIcon,
  },
  methods: {
    submitResetPasswordForm() {
      this.errorMessage = null;
      let url = BACKEND_URL.ResetPasswordForm;

      if (!this.resetForm.password || !this.resetForm.passwordCheck) {
        this.errorMessage =
          "All fields must be filled before submitting the form";
        return;
      }
      if (!(this.resetForm.password === this.resetForm.passwordCheck)) {
        this.errorMessage = "Password and password check must match";
        return;
      }

      this.showLoad = true;

      fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(this.resetForm),
      })
        .then((response) => {
          if (response.ok) {
            this.passwordResetSuccess = true;
            this.showLoad = false;
            this.recoveryTokenHasExpired = false;
          }
        })
        .catch((error) => {
          this.errorMessage = error.text;
        });
    },
  },

  mounted: function () {
    this.showLoad = false;
    this.passwordResetSuccess = false;
    this.recoveryInfo = null;
    this.resetForm.token = this.token;

    let url = BACKEND_URL.RecoverPasswordInfo + "?token=" + this.token;
    fetch(url, {
      method: "GET",
      mode: "cors",
      headers: { Accept: "application/json" },
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status == 404) {
          return null;
        } else {
          throw Error(
            response.status + response.statusText + " " + response.text
          );
        }
      })
      .then((recoveryInfo) => {
        this.recoveryInfo = recoveryInfo;
        if (!recoveryInfo) {
          this.errorMessage =
            "Could not find password recovery info associated with token " + this.token;
          return;
        }
        if (recoveryInfo.expired) {
          this.errorMessage = "This recovery token has expired";
        } else {
          this.resetForm.email = this.recoveryInfo.email;
          this.resetForm.password = null;
          this.resetForm.passwordCheck = null;
          this.$refs.password.focus();
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>

<style lang="scss">
.forgot-title {
  padding-bottom: 30px;
}
#formContainer {
  .info-reset {
    color: #404040;
    font-size: 16px;
    margin: 20px 10px 12px;
  }
  #error-message {
    color: #ff0000;
    font-size: 16px;
  }
}

.expired-token-box {
  display: flex;
  justify-content: center;
}

.success-reset-text {
  text-align: center;
}
</style>